import React, { useContext, useLayoutEffect, useState } from 'react';

import { ToasterGroup } from '@accesa/react-core/build/ui/toaster';

import { LoginComponent } from '../../components/authentication/login';

import { LoginProps } from './props';
import S from './style';
import { getDiscoveryKeys, signinRedirect } from '../../services/authService';
import { AppContext } from '../../AppContext';
import { getDiscoveryConfig } from '../../client/configuration';

const LoginPage: React.FC<LoginProps> = ({ }: LoginProps): React.ReactElement => {
  const { userManager } = useContext(AppContext);
  const [waitingForContentLoad, setWaitingForContentLoad] = useState<boolean>(
    false
  );

  const loginFetchHandler = (event?: React.FormEvent) => {
    if (event) {
      event.preventDefault();
    }
    loginFetch();
  };

  const loginFetch = async () => {
    setWaitingForContentLoad(true);
    redirectLoginHandlerWithCustomer(true);
  };

  const redirectLoginHandlerWithCustomer = async (loginCustomer: boolean) => {
    setWaitingForContentLoad(true);
    setTimeout(function () {
      if (!loginCustomer) {
        setWaitingForContentLoad(false);
      } else {
        setWaitingForContentLoad(false);
        signinRedirect(userManager);
      }
    }, 1000);
  };

  const [hasDiscoveryKeys, setHasDiscoveryKeys] = useState<boolean>();

  const makingSureDataIsPreloaded = () => {
    getDiscoveryConfig().then(() => {
      getDiscoveryKeys().then(() => {
        setHasDiscoveryKeys(true);
      });
    });
  };

  useLayoutEffect(() => {
    if(!hasDiscoveryKeys) {
      makingSureDataIsPreloaded();
    }
  });

  return (
    <S.LoginPageContainer>
      <LoginComponent
        doLoginHandler={() => loginFetchHandler()}
        waitingForContentLoad={waitingForContentLoad}
      />
      <ToasterGroup />
    </S.LoginPageContainer>
  );
};

export default LoginPage;